import Anchor from "../../../../../../shared/lib/html5-software-library/src/ranj/layout/Anchor";
import AppModel from "../../../../../../shared/src/ranj/app/core/AppModel";
import AbstractScreenMediator from "../../../../../../shared/src/ranj/app/ui/AbstractScreenMediator";
import FeedbackPanelView from "../../feedback/FeedbackPanelView";
import InfoPanelView from "../../info-panel/InfoPanelView";

export default class AbstractCollaborationScreenMediator extends AbstractScreenMediator {

    constructor(target, dispatcher, languagePack, layoutManager, soundManager, gameAssets, gameModel) {
        super(target, dispatcher, languagePack, layoutManager, soundManager);
        this._gameAssets = gameAssets;
        this._gameModel = gameModel;
        this._speedFactor = AppModel.speedFactor;

        if (ranj.DEBUG) {
            window.screen = this;
        }
    }

    destroy() {
        super.destroy();
        if (window.screen == this) {
            window.screen = null;
        }
    }

    addInfoPanel(opened = false) {
        const skin = new this._gameAssets.InfoPanelSkin();
        this._target.addChild(skin);
        this._infoPanel = new InfoPanelView(skin, this._languagePack, this._gameAssets);
        this._infoPanel.addEventListener(InfoPanelView.CLOSE, this._handleInfoPanelClose.bind(this));
        this._infoPanel.addEventListener(InfoPanelView.OPEN, this._handleInfoPanelOpen.bind(this));
        if (opened) {
            this._infoPanel.open(true);
        }

        this.anchorObject(skin, Anchor.T);
    }

    checkSavegameRestoredFeedback(y, delay = 1000) {
        if (this._gameModel.restoredFeedbackPending) {
            this._gameModel.restoredFeedbackPending = false;
            this.callDelayed(() => { this.showSavegameRestoredFeedback(y); }, delay);
        }
    }

    showSavegameRestoredFeedback(y = -150) {
        const str = this.getText("savegame.restored");
        this.showFeedback(str, y);
    }
    showFeedback(str, y = -150) {
        const skin = new this._gameAssets.FeedbackPanel();
        skin.y = y;
        this._target.addChild(skin);
        const view = new FeedbackPanelView(skin);
        view.addEventListener(FeedbackPanelView.CLOSE, () => {
            this._target.removeChild(skin);
        });
        view.setText(str, true);
    }

    _handleInfoPanelClose(e) {

    }
    _handleInfoPanelOpen(e) {

    }


    _createFadeOverlay() {
        const shape = this._target.addChild(new createjs.Shape());
        const w = 2000, h = 4000;
        shape.alpha = 0;
        shape.graphics.f(getComputedStyle(document.body).backgroundColor).r(-w / 2, -h / 2, w, h);
        this._fadeOverlay = shape;
    }

    _fadeIn(callback) {
        this._fade(1, 0, callback);
    }

    _fadeOut(callback) {
        this._fade(0, 1, callback);
    }

    _fade(from, to, callback) {
        if (!this._fadeOverlay) {
            this._createFadeOverlay();
        }
        this._fadeOverlay.visible = true;
        this._fadeOverlay.alpha = from;
        const tween = createjs.Tween.get(this._fadeOverlay)
            .to({ alpha: to }, 700 / this._speedFactor, createjs.Ease.quadIn)
            .wait(700 / this._speedFactor);
        if (callback != null) {
            tween.call(callback);
        }
    }
}
